import { createSlice } from '@reduxjs/toolkit'
import axios from 'axios'

const listSlice = createSlice({
  name: 'lists',
  initialState: {
    allLists: [], // Kaikki vaatimuslistat
    allListsLoaded: false,
    listPlayers: {}, // Listan pelaajat cache: { listId: [players] }
  },
  reducers: {
    setAllLists(state, action) {
      state.allLists = action.payload
      state.allListsLoaded = true
    },
    addList(state, action) {
      state.allLists.push(action.payload)
    },
    removeList(state, action) {
      const id = action.payload
      state.allLists = state.allLists.filter(l => {
        const lId = l.id || l._id
        return lId !== id
      })
      delete state.listPlayers[id]
    },
    setListPlayers(state, action) {
      const { id, players } = action.payload
      state.listPlayers[id] = players
    },
    clearAllLists(state) {
      state.allLists = []
      state.allListsLoaded = false
      state.listPlayers = {}
    },
  },
})

export const {
  setAllLists,
  addList,
  removeList,
  setListPlayers,
  clearAllLists,
} = listSlice.actions

/**
 * Hakee kaikki vaatimuslistat. Palauttaa cachesta jos jo ladattu.
 */
export const initializeLists = token => {
  return async (dispatch, getState) => {
    const { lists } = getState()
    if (lists.allListsLoaded) {
      return lists.allLists
    }
    try {
      const response = await axios.get(`/list/${token}`)
      dispatch(setAllLists(response.data))
      return response.data
    } catch (error) {
      console.error('Error fetching lists:', error)
      return []
    }
  }
}

/**
 * Hakee listan pelaajat. Palauttaa cachesta jos löytyy.
 */
export const fetchListPlayers = (listId, token) => {
  return async (dispatch, getState) => {
    const { lists } = getState()
    if (lists.listPlayers[listId]) {
      return lists.listPlayers[listId]
    }
    try {
      const response = await axios.get(`/list/filter/${listId}`, {
        headers: { 'x-oauth-token': token },
      })
      dispatch(setListPlayers({ id: listId, players: response.data }))
      return response.data
    } catch (error) {
      console.error('Error fetching list players:', error)
      return []
    }
  }
}

export default listSlice.reducer
